import {Dispatch, FC, ReactNode, SetStateAction} from 'react';
import {useTranslation} from 'react-i18next';
import Modal from '../Modal';

export type ModalDestructiveConfirmProps = {
    cancel?: ReactNode;
    children: ReactNode;
    header: ReactNode;
    isOpen: boolean;
    onCancel: Dispatch<SetStateAction<boolean>>;
    onConfirm: () => void;
    submit?: ReactNode;
};

const ModalDestructiveConfirm: FC<ModalDestructiveConfirmProps> = ({
    cancel,
    children,
    header,
    isOpen,
    onCancel,
    onConfirm,
    submit,
}) => {
    const {t} = useTranslation();

    return (
        <Modal isOpen={isOpen} onClose={() => onCancel(false)}>
            <Modal.Header>{header}</Modal.Header>
            <Modal.Body>{children}</Modal.Body>
            <Modal.Footer>
                <Modal.Button
                    id="modal-cancel"
                    kind="secondary"
                    onClick={() => onCancel(false)}
                    size="sm"
                    type="cancel"
                >
                    {cancel || t('form:cancel')}
                </Modal.Button>
                <Modal.Button
                    id="modal-delete"
                    kind="destructive"
                    onClick={onConfirm}
                    size="sm"
                    type="submit"
                >
                    {submit || t('form:delete')}
                </Modal.Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalDestructiveConfirm;
